import React, { useEffect, useState } from "react";
import "./reflections.scss";
import CommonBanner from "../../components/commonBanner/CommonBanner";
import { flower, interviewFormBg, searchIcon, upDownArrow } from "../../source";
import { mainPostData } from "../../data/reflections";
import { Link, useNavigate } from "react-router-dom";
import CommonCta from "../../components/CommonCta/CommonCta";
import { useWindowSize } from "react-use";
import { reflectionsURL } from "../../helpers/constants";
import config from "../../config/config";
import Joi from "joi";
import http from "../../helpers/http";
import MetaDecorator from "../../components/MetaDecorator/MetaDecorator";
const Reflections = () => {
  const { width } = useWindowSize();
  const [isTabSelected, setIsTabSelected] = useState(mainPostData[0].catergory);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    topic: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const schema = Joi.object({
    name: Joi.string().trim().required().messages({
      "string.empty": "Name is required",
      "any.required": "Name is required",
    }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .messages({
        "string.empty": "Email is required",
        "string.email": "Please enter a valid email address",
        "any.required": "Email is required",
      }),
    topic: Joi.string().required().messages({
      "string.empty": "Topic to Explore is required",
      "any.required": "Topic to Explore is required",
    }),
  });

  const mainPostFilter = mainPostData.filter(
    (data) => data.catergory === isTabSelected
  );

  const tabList = mainPostData.map((tab, i) => (
    <button
      className={`pill_btn ${isTabSelected === tab.catergory ? "active" : ""}`}
      onClick={() => setIsTabSelected(tab.catergory)}
      key={i}
    >
      {tab.name}
    </button>
  ));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowThankYou(false);

    // Validate form data
    const { error } = schema.validate(formData, { abortEarly: false });
    if (error) {
      const validationErrors = {};
      error.details.forEach((detail) => {
        validationErrors[detail.path[0]] = detail.message;
      });
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      const response = await http.post(
        `${config.api_url}/blog-leads`,
        formData
      );

      if (response) {
        // Reset form
        setFormData({
          name: "",
          email: "",
          topic: "",
        });

        // Show thank you message
        setShowThankYou(true);

        // Hide thank you message after 5 seconds
        setTimeout(() => {
          setShowThankYou(false);
        }, 5000);
      } else {
        throw new Error("Failed to submit form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsSubmitting(false);
    }
  };

  const mainPostList = mainPostFilter.map((item, i) => (
    <div className="row posts_row" key={i}>
      <div className="col-lg-7 posts_col">
        <div
          className="posts_box"
          onClick={() => navigate(`${reflectionsURL}/${item.slug}`)}
        >
          <div className="img_wrapper">
            <img src={item.img} alt={item.alt} className="post_img" />
          </div>
          <div className="content_wrapper">
            <p className="section_desc22">{item.date}</p>
            <h2 className="section_heading48">{item.title}</h2>
            <h6 className="author">{item.author}</h6>
          </div>
        </div>

        {/* <div className="row catergory_row">
          {item?.categoriesData.map((cat, index) => (
            <div
              className="col-md-6 catergory_col"
              key={index}
              data-aos="fade-up"
            >
              <Link to={cat.slug}>
                <div className="catergory_box">
                  <div className="cat_img_wrapper">
                    <img
                      src={width <= 767 && cat.mbImg ? cat.mbImg : cat.img}
                      alt={cat.alt}
                      className="cat_img"
                    />
                    <p className="cat_type">{cat.type}</p>
                  </div>
                  <div className="cat_content">
                    <p className="cat_date">{cat.date}</p>
                    <h4 className="cat_title">{cat.title}</h4>
                    <h6 className="cat_author">{cat.author}</h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div> */}
      </div>

      <div className="col-lg-5 posts_col">
        {/* <div className="most_posts_wrapper">
          <h2 className="most_main_title">Most Read</h2>
          {item?.mostRead.map((most, index) => (
            <div className="row most_posts_row" data-aos="fade-up">
              <div className="col-md-4 col-5 most_col" key={index}>
                <div className="most_img_wrapper">
                  <img
                    src={width <= 767 && most.mbImg ? most.mbImg : most.img}
                    alt={most.alt}
                    className="most_img"
                  />
                </div>
              </div>
              <div className="col-md-8 col-7 most_col">
                <div className="most_content_wrapper">
                  <p className="most_date">{most.date}</p>
                  <h2 className="most_title">{most.title}</h2>
                  <Link to={most.slug} className="link">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div> */}

        <form
          className="posts_form form_wrapper"
          data-aos="fade-up"
          onSubmit={handleSubmit}
        >
          <img src={interviewFormBg} alt="background" className="bg_img" />
          <h2 className="form_title">
            Request a topic to explore or a teacher to interview
          </h2>
          <div className="input_wrapper">
            <input
              type="text"
              name="name"
              className="input_field"
              placeholder="Name*"
              value={formData.name}
              onChange={handleInputChange}
            />
            <p className="error">{errors.name || ""}</p>
          </div>
          <div className="input_wrapper">
            <input
              type="text"
              name="email"
              className="input_field"
              placeholder="Email*"
              value={formData.email}
              onChange={handleInputChange}
            />
            <p className="error">{errors.email || ""}</p>
          </div>
          <div className="input_wrapper">
            <input
              type="text"
              name="topic"
              className="input_field"
              placeholder="Topic to Explore*"
              value={formData.topic}
              onChange={handleInputChange}
            />
            <p className="error">{errors.topic || ""}</p>
          </div>
          {errors.submit && <p className="error">{errors.submit}</p>}
          <div>
            <CommonCta
              text={isSubmitting ? "SUBMITTING..." : "SUBMIT"}
              type="submit"
              disabled={isSubmitting}
            />
            {/* {showThankYou && (
              <p style={{ color: "white", margin: 0, fontSize: "14px" }}>
                Thank you for your submission!
              </p>
            )} */}
          </div>
          <div className="thank_msg_wrapper">
            {showThankYou && (
              <p className="thank_text">Thank you for your submission!</p>
            )}
          </div>
        </form>
      </div>
    </div>
  ));

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <>
      <MetaDecorator
        canonicalLink={window.location.href}
        metaTitle="Personal Reflections, Meditation & Self Care Practices - Pathways & Perspectives"
        metaDesc="Dive into mindful reflections,insights, and guided exercises from Pathways & Perspectives. Cultivate self-awareness, emotional growth, and soulful clarity."
      />

      <section className="reflections_sec1">
        <CommonBanner title="Reflections" linkText1="Reflections" />
      </section>

      <section className="reflections_sec2" data-aos="fade-up">
        <img src={upDownArrow} alt="up down arrow" className="up_down_arrow" />
        {width > 767 && (
          <img src={flower} alt="flower" className="flower_img" />
        )}
        {/* <div className="my_container">
          <form className="search_form form_wrapper">
            <div className="input_wrapper">
              <div className="search_wrapper">
                <img
                  src={searchIcon}
                  alt="search icon"
                  className="search_icon"
                />
                <input
                  type="text"
                  placeholder="Search Topic"
                  className="input_field"
                />
              </div>
            </div>
          </form>
        </div> */}

        <div className="tabs_data">
          <div className="my_container">
            <div className="tab_conatiner">
              <div className="tab_wrapper">{tabList}</div>
            </div>
          </div>
        </div>

        <div className="my_container">
          <div className="posts_wrapper">{mainPostList}</div>
        </div>
      </section>
    </>
  );
};

export default Reflections;
